import logoBlue from '@/assets/trionix-logo-blue.png';
import logoOnlyBlue from '@/assets/trionix-logo-only-blue.png';

interface TrionixLogoProps {
  size?: number;
  className?: string;
  variant?: 'full' | 'icon'; // 'full' for logo with text, 'icon' for logo only
}

const TrionixLogo = ({ size = 52, className = "", variant = 'full' }: TrionixLogoProps) => {
  const logoSrc = variant === 'full' ? logoBlue : logoOnlyBlue;
  
  return (
    <img 
      src={logoSrc} 
      alt="Trionix Technologies Logo" 
      className={`flex-shrink-0 ${className}`}
      style={{ 
        width: size, 
        height: 'auto',
        background: 'transparent',
        display: 'block',
        mixBlendMode: 'normal',
        isolation: 'isolate'
      }}
    />
  );
};

export default TrionixLogo;
